<template>
    <span
        class="model-status-label"
        :class="{'blue': modelStatusLabel === 'Published'}"
    >
        {{modelStatusLabel}}
    </span>
</template>

<script>
export default {
  props: {
    model: Object
  },

  computed: {
    modelStatusLabel () {
      const publishedVersionId = _
        .get(this.$props.model, 'endpoints.PRODUCTION.publishedVersionId', false)

      return publishedVersionId ? 'Published' : 'Not Published'
    }
  }
}
</script>

<style lang="scss" scoped>
    .model-status-label {
        font-size: 12px;
        color: $or-grey;

        &.blue {
            color: $or-blue;
        }
    }
</style>
